import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../../styles/style.css';

function NotifyModal({setIsDepositOpen, setIsNotifyOpen}) {
    const { t } = useTranslation()

    return (
        <>
            <div className={'notify-modal-wrapper'}>
                <div className={'notify-modal-container'}>
                    <div style={{"textAlign": "center", "fontWeight": "600", "padding": "10px", "color": "#5B5B5B"}}>
                        Hisobingizda yetarli mablag' mavjud emas! O'ynash uchun hisobingizni to'ldiring va katta yutuqlarga ega bo'ling! Omad!
                    </div>
                    <div className={'notify-modal-buttons-wrapper'}>
                        <div className={'notify-modal-button deposit'} onClick={() => {
                            setIsDepositOpen(true)
                            setIsNotifyOpen(false)
                        }}>{t("mp_deposit")}</div>
                        <div className={'notify-modal-button close'} onClick={() => setIsNotifyOpen(false)}>{t("mp_close")}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotifyModal;